import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { SCREENS } from '../../../constants/tracking/Locations';
import LimitUsageFeatureRow from './LimitUsageFeatureRow';

const LimitUsageSection = ({
  limitUsages,
  width = '60%'
}) => {
  const hasUsage = limitUsages.some(obj => obj.usage > 0);
  useEffect(() => {
    getUsageTracker().track('limitUsageView', {
      screen: SCREENS.SUITE_STARTER,
      hasUsageOnLimits: hasUsage
    });
  }, [hasUsage]);
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-0",
    style: {
      maxWidth: '90%',
      width
    },
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-5",
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ebxInterstitialPage.LimitUsageSection.header"
      })
    }), limitUsages.map(limitUsage => /*#__PURE__*/_jsx(LimitUsageFeatureRow, {
      limitUsage: limitUsage
    }, limitUsage.limitName))]
  });
};

export default LimitUsageSection;